export const CARD_CONSULT__APPROVED = 'approved';
export const CARD_CONSULT__UNSURE = 'unsure';
export const CARD_CONSULT__WAITING = 'waiting';
